export default {
  mainRecommandations: {
    tutorialTitle: 'Découvrir comment jouer du piano avec Tokatab !',
    continue: "➡️ Reprendre l'exercice",
    discover: 'Découvrir Tokatab',
    continueCourse: 'Continuer le cours',
    startLearningNewPiece: 'Commencer à apprendre un nouveau morceau',
    continueModule: 'Continuer le module',
    reviewConcept: 'Réviser la notion',
    startNewModule: 'Commencer un nouveau module',
    discoverTokatab: 'Découvrir Tokatab',
    finishedAllSkills: 'Félicitations pour avoir terminé toutes les compétences de votre parcours !',
    goToNextLevel: 'Passer au parcours suivant',
    alreadyMaxLevel: 'Vous êtes déjà au niveau le plus élevé !',
    buyPianoLabel: 'Équipement',
    buyPianoTitle: 'Acheter un piano ou clavier et revenir apprendre sur Tokatab',
  },
  catalogEntry: {
    challenge: 'Challenge',
    piece: 'Morceau',
  },
  userRevisionPage: {
    title: 'À réviser',
    contentToRevise: 'Vous avez {count} contenu{plural} à réviser',
    contentToReviseDesktop: 'Vous avez {count} contenu{plural} que vous pouvez réviser',
    emptyMessage: 'Vous avez déjà tout révisé !'
  },
  userCatalogPage: {
    title: 'Mon historique',
    inProgress: 'En cours',
    completed: 'Terminés',
    noInProgressMessage: 'Aucun morceau en cours',
    noCompletedMessage: 'Pour l\'instant vous n\'avez pas encore appris de morceau en entier.'
  },
  importMusicxmlPiecePage: {
    title: 'Ajouter un morceau',
    errorPersist: 'Si l\'erreur persiste veuillez',
    contactSupport: 'contacter le support.',
    selectFile: 'cliquez ici pour sélectionner une partition au format .musicxml dans vos fichiers',
    loadingFile: 'Chargement du fichier...',
    acceptedFormats: 'Formats acceptés : .xml, .musicxml, .mxl.',
    whatIsMusicxml: 'Qu\'est ce que le .musicxml et où trouver des partitions dans ce format?',
    titleLabel: 'Titre',
    artistLabel: 'Artiste',
    musicStyleLabel: 'Style musical (Optionnel)',
    coverImageLabel: 'Image de couverture (optionnel)',
    importButton: 'Importer le morceau',
    importLoading: 'L\'importation peut prendre quelques minutes...',
    importSuccess: 'Morceau importé avec succès !',
    unknownError: 'Une erreur inconnue est survenue lors de l\'import du morceau.',
    getHelp: 'Obtenir de l\'aide',
    pieceDetails: 'Informations sur le morceau',
    dropHere: 'Déposer le fichier ici'
  },
  importMusicxmlErrors: {
    UNHANDLED_EXCEPTION: 'Une exception non gérée s\'est produite.',
    ISSUE_IN_MUSICXML_FILE: 'Le fichier MusicXML contient des erreurs.',
    MULTI_VOICE_NOT_SUPPORTED: 'Les partitions à voix multiples ne sont pas supportées.',
    TUPLETS_NOT_SUPPORTED: 'Les notes en triolets ou autres rythmes complexes ne sont pas supportés.',
    MISSING_FINGERING: 'Certaines notes n\'ont pas de doigté.',
    FILE_NOT_FOUND: 'Le fichier MusicXML est introuvable.',
    NO_TIME_SIGNATURE: 'La partition doit contenir une indication de mesure (ex : 4/4, 3/4, etc.).',
    NO_HANDPRINT_FOUND: 'Aucune empreinte généré dans la partition.',
    NOTE_NOT_IN_HANDPRINT: 'Certaines notes ne sont pas dans l\'empreinte.',
    PIECE_ALREADY_EXISTS: 'Cette partition existe déjà dans votre bibliothèque.',
    INVALID_FILE_TYPE: 'Le type de fichier n\'est pas valide. Veuillez utiliser un fichier .xml ou .musicxml.',
    NO_MELODIC_POSITION_AND_NO_CHORDS_ON_EXISTING_HANDPRINT: 'L\'empreinte ne contient aucune position mélodique et aucun accord, ce qui n\'est pas compatible avec une empreinte existante pour le même morceau.',
    CHORD_BASED_EXISTING_HANDPRINT_WITHOUT_CHORDS: 'L\'empreinte est basée sur des accords mais n\'en contient aucun, ce qui n\'est pas compatible avec une empreinte existante pour le même morceau.',
    CHORD_SPAN_VERY_SMALL: 'L\'étendue des accords dans l\'empreinte est très petite, ce qui peut causer des problèmes de doigté.',
    PINEAPPLE_API_ERROR: 'Une erreur est survenue lors de la communication avec l\'API Pineapple.',
    PINEAPPLE_API_NOT_ALL_FINGERINGS_RECEIVED: 'Toutes les doigtés n\'ont pas été reçues de l\'API Pineapple.',
    handLabel: 'Main:',
    measureLabel: 'Mesure:',
    divisionLabel: 'Division :'
  },
  importMusicxmlSteps: {
    labels: {
      PENDING: 'En attente',
      STARTED: 'Démarré',
      FINGERING_FILLING: 'Remplissage des doigtés',
      PENDING_JOB: 'En attente de traitement',
      MUSICXML_PARSING: 'Analyse du MusicXML',
      HANDPRINT_PARSING: 'Analyse des empreintes',
      RHYTHMIC_PARSING: 'Analyse des rythmiques',
      TIMELINE_GENERATION: 'Génération de la timeline',
      COMPLETED: 'Terminé',
      FAILED: 'Échoué',
    },
    descriptions: {
      PENDING: 'Votre import est en attente de traitement.',
      STARTED: 'Votre import a démarré.',
      FINGERING_FILLING: 'Nous remplissons les doigtés manquants dans votre partition.',
      MUSICXML_PARSING: 'Nous analysons le fichier MusicXML pour extraire les informations musicales.',
      HANDPRINT_PARSING: 'Nous analysons l\'empreinte pour associer les notes aux positions de la main.',
      RHYTHMIC_PARSING: 'Nous analysons le rythme de la partition.',
      TIMELINE_GENERATION: 'Nous générons la timeline pour la lecture du morceau. Cette étape peut prendre du temps',
      COMPLETED: 'Votre import est terminé avec succès !',
      FAILED: 'Une erreur est survenue lors de l\'import de votre partition.',
    }
  },
  homePage: {
    logoAlt: 'Logo Tokatab',
    yourProgress: 'Votre progression',
    discoveryPath: 'Parcours découverte',
    missions: '{completed} / {total} missions',
    coursePath: 'Niveau {levelName}',
    completedAt: 'Terminé à {percentage}',
    greeting: 'Bonjour, {firstName} 👋',
    regularity: 'Régularité',
    weeksCount: '{count}/4 sem.',
    level: 'Niveau',
    resumeWhereYouLeft: 'Reprendre où vous en étiez',
    teacherSuggests: 'Votre prof vous suggère',
    activitiesToProgress: 'Activités pour progresser aujourd\'hui',
    piecesInProgress: 'Morceaux en cours',
    add: 'Ajouter',
    pieceInProgress: 'Morceau en cours',
    exerciseInProgress: 'Exercice en cours',
    videoInProgress: 'Vidéo en cours',
    inProgress: 'En cours',
    teacherRecommendations: 'Recommandations du prof Tokatab',
    welcomeMessageCongratsPieces: 'Bravo pour {text} ! Maintenant, je vous suggère de ',
    welcomeMessageCongratsModules: 'Bravo pour {text} ! Maintenant, je vous suggère de ',
    welcomeMessageCongratsSkills: 'Bravo pour {text} ! Maintenant, je vous suggère de ',
    welcomeMessageCongratsChallenges: 'Bravo pour {text} ! Maintenant, je vous suggère de ',
    welcomeMessageCongratsExercises: 'Bravo pour {text} ! Maintenant, je vous suggère de ',
    welcomeMessageDefault: 'Bonjour {firstName} ! Voici de quoi progresser aujourd\'hui :',
    welcomeMessageReturn: 'Bonjour {firstName} ! Content de vous retrouver ! Voici ce que je vous propose de faire :',
    welcomeMessageGreatSession: 'Bonjour {firstName} ! C\'est parti pour une super session aujourd\'hui ! Voici ce que je vous propose :',
    welcomeMessageContinue: 'Maintenant, je vous suggère de ',
    progressRecommendations: 'Voici mes recommandations pour progresser',
    priorityContentToRevise: 'Ici les contenus prioritaires parmi les {count} à réviser ({seeAllLink})',
    seeAll: 'Voir tout',
    applySkillsText: 'Pour appliquer vos compétences dans des morceaux ou des challenges',
    revisions: 'Révisions',
    seeMore: 'Voir plus',
    history: 'Historique',
    piecesValidated: 'les morceaux validés',
    pieceValidated: 'le morceau validé',
    modulesValidated: 'les modules validés',
    moduleValidated: 'le module validé',
    skillsValidated: 'les compétences validées',
    skillValidated: 'la compétence validée',
    challengesValidated: 'les challenges validés',
    challengeValidated: 'le challenge validé',
    exercisesValidated: 'les exercices validés',
    exerciseValidated: 'l\'exercice validé',
    loadingMessage: 'Je prépare vos recommandations personnalisées...'
  },
  catalogPage: {
    searchPlaceholder: 'Rechercher par titre ou artiste',
    sortBy: 'Trier par {sortType}',
    filters: 'Filtres',
    filtersWithCount: 'Filtres ({count})',
    validate: 'Valider',
    recommendations: 'Recommandations',
    pieces: 'Morceaux',
    noResults: 'Aucun résultat',
    noResultsTitle: 'Aucun morceau trouvé',
    noResultsSearch: 'Aucun résultat pour « {query} ». Essayez avec d\'autres mots-clés ou ajustez vos filtres.',
    noResultsFilters: 'Aucun morceau ne correspond à vos filtres actifs. Essayez de les modifier.',
    importPiece: 'Importer une partition',
    resetFilters: 'Réinitialiser',
    addPiece: 'Ajouter un morceau',
    addPieceDescription: 'Importe une partition au format musicXML et joue là avec Tokatab',
    sortTypeDefault: 'Maitrise',
    catalog: 'Catalogue',
    songsCount: '{count} morceau | {count} morceaux',
  },
  challengesPage: {
    title: 'Challenges',
    searchPlaceholder: 'Rechercher par titre ou artiste',
    recommendations: 'Recommandations',
    difficultyNovice: 'Novice',
    difficultyBeginner: 'Débutant',
    difficultyIntermediate: 'Intermédiaire',
    difficultyAll: 'Tout',
    completedChallenges: 'Vous avez validé <span class="text-blue-7 text-weight-bold">{count}/{max}</span> challenge(s)',
    noResultsTitle: 'Aucun challenge trouvé',
    noResultsSearch: 'Aucun résultat pour « {query} ». Essayez avec d\'autres mots-clés.',
    noResultsDifficulty: 'Aucun challenge disponible dans cette difficulté pour l\'instant.',
  },
  otherSuggestionsModal: {
    title: 'Autres suggestions',
    tabRevisions: 'Révisions',
    tabModules: 'Modules',
    tabPieces: 'Morceaux',
    tabChallenges: 'Challenges',
    emptyRevisions: 'Je n\'ai pas de révision à vous recommander pour l\'instant.',
    emptyModules: 'Vous avez terminé tous les modules de votre niveau, vous pouvez passer au niveau supérieur !',
    emptyPieces: 'Je n\'ai pas de morceaux à vous recommander pour l\'instant, mais vous pouvez explorer le répertoire.',
    emptyChallenges: 'Je n\'ai pas de challenges à vous recommander pour l\'instant, mais vous pouvez explorer les challenges en cliquant sur le bouton ci-dessous.',
    seeMore: 'Voir plus',
    seeOtherLessons: 'Voir d\'autres leçons',
    explorePieces: 'Explorer les morceaux',
    exploreChallenges: 'Explorer les challenges'
  },
  courseLevelSelector: {
    title: 'Consulter les parcours',
    evaluationBannerText: 'Vérifions votre niveau avec quelques défis.',
    evaluationBannerButton: 'Passer le test',
    evaluationBannerSkip: 'Non merci',
    activeCourse: 'Parcours actif',
    otherCourses: 'Autres parcours',
    higherLevels: 'Niveaux supérieurs',
    lowerLevels: 'Niveaux inférieurs',
    warningMessage: 'Je ne vous conseille pas de commencer ce parcours, vous risqueriez d\'avoir des difficultés et de prendre de mauvais réflexes.',
    skillsValidated: 'Les compétences du parcours en cours seront automatiquement validées.',
    notRecommended: 'Nous vous déconseillons de commencer ce parcours',
    riskDifficulties: 'vous risqueriez d\'avoir des difficultés et de prendre de mauvais réflexes.',
    skillsInvalidated: 'Les compétences du nouveau parcours seront dévalidées et remises à jour selon l\'avancement actuel de votre profil.',
    changeCourse: 'Changer de parcours',
    cancel: 'Annuler',
    evaluationNotification: 'Vous pourrez retrouver le test à tout moment dans votre profil.',
    loading: 'Cette opération peut prendre quelques instants, merci de patienter.',
    alreadyMaxLevel: 'Vous êtes déjà au niveau le plus élevé !'
  },
  homeWelcomeModal: {
    continue: 'Continuer',
    newPiecesMultiple: '{count} nouveaux morceaux arrangés par l\'équipe ont été ajoutés au répertoire !',
    newPieceSingle: 'Un nouveau morceau arrangé par l\'équipe a été ajouté au répertoire!',
    recommendations: 'Recommandations du prof',
  },
  toPlayTodayModal: {
    launchButton: 'Je ne sais pas quoi jouer !',
    greeting: 'Salut {firstName} !',
    timeQuestion: 'Combien de temps voulez-vous consacrer à Tokatab pour cette séance ?',
    shortTime: 'J\'ai peu de temps',
    shortTimeSubtitle: '(~ 15 minutes)',
    mediumTime: 'J\'ai du temps',
    mediumTimeSubtitle: '(~ 30 minutes)',
    longTime: 'J\'ai tout mon temps',
    longTimeSubtitle: '(plus de 30 minutes)',
    regularityTip: 'Pour progresser au piano, la régularité est importante ; mieux vaut plusieurs séances courtes chaque semaine, qu\'une seule session de 3h chaque mois.',
    about15Minutes: 'Environ 15 minutes',
    continueProgress: 'Pourquoi ne pas continuer à avancer sur le parcours pédagogique ?',
    progressDescription: 'Cela ne vous prendra que quelques minutes et vous permettra de progresser en vous amusant !',
    resumeCourses: 'Reprendre les cours',
    nextExercise: 'Prochain exercice',
    about30Minutes: 'Environ 30 minutes',
    challengesStarted: 'Vous avez commencez ces challenges mais ne les avez jamais terminée',
    challengesRecommended: 'Voici une sélection de challenges juste pour vous !',
    challengesDescription: 'Les finir vous permettra d\'augmenter vos scores de maîtrise sur tout le répertoire !',
    moreThan30Minutes: 'Plus de 30 minutes',
    piecesStarted: 'Continuons l\'apprentissage de ce(s) morceau(x) !',
    piecesRecommended: 'Voici une sélection de morceaux qui devrait être à votre niveau !',
    piecesDescription: 'Si vous travaillez régulièrement vous pourrez bientôt jouer comme un pro !',
    close: 'fermer'
  },
  newVersionRecommendations: {
    continue: 'Continuer',
    congratulationsSingle: 'Bravo. Ce morceau est désormais à votre portée !',
    congratulationsMultiple: 'Bravo. Ces morceaux sont désormais à votre portée !'
  },
  homePieceCourses: {
    piecesInProgress: '{count} morceaux en cours',
    completedAt: 'Terminé à {percentage}%',
    removeFromProgress: 'Retirer des morceaux en cours',
    continueCourse: 'Continuer le cours',
    removedMessage: 'J\'ai retiré {title} de vos morceaux en cours, il sera automatiquement ajouté dès que vous reprendrez la progression du cours.',
    loading: 'Chargement...'
  },
  homeOnboardingChecklist: {
    title: 'Parcours Découverte',
    freeDaysToUnlock: '{days} jour de période d\'essai à débloquer',
    freeDaysToUnlockPlural: '{days} jours de période d\'essai à débloquer',
    missionsProgress: '{completed}/{total} missions complétées',
    bannerHtml: '<strong>Complétez ces missions</strong> pour découvrir et enrichir votre expérience avec Tokatab.',
  },
  buySongModal: {
    title: 'Ajouter cette musique à votre catalogue',
    description: 'Apprenez à jouer ce morceau dès maintenant en l\'ajoutant à votre collection !',
    notYetAvailableMessage: 'Merci pour votre intérêt ! Nous ne permettons pas encore l\'achat mais nous avons noté votre intention et reviendrons vers vous très prochainement.'
  },
  homeSuggestionCard: {
    discoverSkill: 'Commencer la compétence',
    validateSkill: 'Valider la compétence',
    continueWorking: 'Continuer la compétence',
    rework: 'Retravailler',
    review: 'Réviser',
    playChallenge: 'Jouer un challenge',
    categoryMission: 'Mission',
    categoryTutorial: 'Tutoriel',
    categoryLevelUp: 'Monter en niveau',
    categoryExercise: 'Exercice',
    categorySkill: 'Compétence',
    categoryModule: 'Module',
    categoryPiece: 'Morceau',
    categoryChallenge: 'Challenge',
    categoryBuyPiano: 'Équipement',
  },
  homeContent: {
    seeMore: 'Voir plus',
    reviewAConcept: 'Révisez une notion',
    lessons: 'Leçons',
    exercisesPlaceholder: 'Vous trouverez ici des exercices à réviser quand j\'estimerai que vous en aurez besoin.',
    recommendations: 'Recommandations',
    toProgress: 'Pour progresser',
    easyToPlay: 'Facile à jouer',
    news: 'Nouveautés',
    filters: 'Filtres',
    recentlyPlayed: 'Récemment joué',
    teacherSuggestion: 'Suggestion du professeur',
    improvingRecommendations: 'Nous travaillons à améliorer les recommandations, des morceaux et challenges s\'afficheront bientôt ici !',
    exploreInMeantime: 'En attendant vous pouvez explorer les',
    challenges: 'challenges',
    or: 'ou le',
    repertoire: 'répertoire',
    findPieceToPlay: 'pour trouver un morceau à jouer !',
    improveRecommendationsMessage: 'Pour améliorer vos recommandations, il vous faut travailler encore quelques morceaux !'
  },
  courseLevelCard: {
    skillGroupsCount: '{count} catégories de compétences :',
    modulesToValidateCount: '{count} modules à valider :',
    skills: 'Voir le détail',
    lessons: 'Leçons',
    select: 'Sélectionner',
    seePath: 'Voir le parcours',
    levelName: 'Niveau {name}'
  },
  schoolItem: {
    rework: 'retravailler',
    review: 'réviser',
    modules: 'Modules',
    premium: 'Premium',
    toRework: 'À retravailler',
    toReview: 'À réviser'
  },
  homeModuleCard: {
    title: 'Les leçons Tokatab',
    description: 'Des modules pédagogiques, pour tous les niveaux, qui vous permettront d\'acquérir ou renforcer les techniques du piano.',
    viewLessons: 'Voir les leçons'
  },
  catalogItem: {
    accompanimentPiano: '(Piano d\'accompagnement)',
    toRework: '- À retravailler',
    toReview: '- À réviser',
    premium: 'Premium'
  },
  catalogEntryPopup: {
    notInterested: 'Ce morceau ne m\'intéresse pas',
    info: 'Infos',
    play: 'Jouer',
    learn: 'Apprendre',
    resumeCourse: 'Reprendre le cours',
    playFree: 'Jouer le morceau',
    bothHands: 'à deux mains',
    rightHand: 'main droite',
    leftHand: 'main gauche',
    masteredPiece: 'Bravo ! Vous maitrisez ce morceau. N\'hésitez pas à le rejouer de temps en temps pour ne pas l\'oublier !',
    addToPieceCourses: 'Ajouter aux morceaux en cours'
  },
  catalogMiniature: {
    accompanimentPiano: 'Piano d\'accompagnement'
  },
  difficultyIndicator: {
    generic: 'Générique',
    novice: 'Novice',
    beginner: 'Débutant',
    intermediate: 'Intermédiaire',
    advanced: 'Avancé',
    pro: 'Pro'
  }
};
